import { Truck } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/Tooltip"
import { num, shortDate } from "../format"
import type { IncomingSummary } from "../types"

// Days of cover today and, when orders are on the way, once they have landed
// ("146 → 303"): more stock coming on top of what is already too much. A
// product with nothing going out has no incoming figure, so `incoming` comes
// only with a DOC.
export default function DocCell({ doc, incoming }: { doc: number | null; incoming: IncomingSummary | null }) {
  const today = doc === null ? "No movement" : num(doc)
  if (!incoming) {
    return <span className="w-28 whitespace-nowrap text-right text-sm font-semibold tabular-nums">{today}</span>
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex w-28 items-center justify-end gap-1 whitespace-nowrap text-sm tabular-nums">
          {today}
          <span aria-hidden>→</span>
          <span className="font-semibold">{num(incoming.doc)}</span>
          <Truck className="h-3.5 w-3.5 shrink-0" aria-label="after incoming orders" />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        {today} days now, {num(incoming.doc)} days once {num(incoming.quantity)} incoming units land (last order due {shortDate(incoming.last_arrives_on)}).
      </TooltipContent>
    </Tooltip>
  )
}
